// extracted by mini-css-extract-plugin
export default {"form":"OEveb","button":"GljTk","info":"RHE5c","errorMessage":"BsVHd","infoItem":"_tgiZ","infoText":"OKIfE","passwordIcon":"VDOlV","reCaptcha":"kmDr3"};